import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import Stats from './components/Stats';
import PublishedFilters from './components/PublishedFilters';
import DealsTable from './components/DealsTable';
import TrinityResult from './components/modals/TrinityResult';
import {
  fetchDeals,
  changeViewType,
  fetchCountryOptions,
  selectViewType,
} from '../../../redux/reducers/brand/ConfirmedDealsReducer';

const PublishedDeals = ({
  dispatch,
  viewType,
  history,
  location,
}) => {
  const brandName = useSelector(state => state.session?.advertiser?.companyName || 'Brand');

  useEffect(() => {
    document.title = `${brandName} Brand Confirmed Deals, Published`;
  }, [brandName]);

  useEffect(() => {
    // Fetch country options on mount
    dispatch(fetchCountryOptions());
    // Ensure viewType is 'published' and fetch deals
    if (viewType !== 'published') {
      dispatch(changeViewType('published'));
    } else {
      dispatch(fetchDeals());
    }
  }, [dispatch, viewType]);

  return (
    <Container>
      <Row>
        <Col md={12}>
          <h2>Confirmed Deals: Published</h2>
          <p className="text-muted mb-3 mt-0">View published deals and their performance</p>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <PublishedFilters />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Stats />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <DealsTable history={history} location={location} />
        </Col>
      </Row>
      <TrinityResult />
    </Container>
  );
};

PublishedDeals.propTypes = {
  dispatch: PropTypes.func.isRequired,
  viewType: PropTypes.string.isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  location: PropTypes.objectOf(PropTypes.any).isRequired,
};

const mapStateToProps = state => ({
  viewType: selectViewType(state),
});

export default connect(mapStateToProps)(PublishedDeals);
